/** Public URLs stay English; existing UI/assistant section identifiers are internal. */
export const institutionSectionSlugs = {
  inicio: "home", turmas: "classes", aulas: "lessons", atividades: "activities",
  reunioes: "meetings", formularios: "forms", agenda: "agenda", relatorios: "reports", pessoas: "people", configuracoes: "settings",
} as const;

export function institutionalRouteSegments(segments: string[]) {
  const result = [...segments];
  const section = Object.entries(institutionSectionSlugs).find(([, slug]) => slug === result[0]);
  if (section) result[0] = section[0];
  if (result[0] === "turmas" && result[2] === "subjects") result[2] = "disciplinas";
  return result;
}

export function canonicalInstitutionPathname(pathname: string) {
  const match = pathname.match(/^(\/(?:pt-br|en-gb|es-es))?(\/platform\/[a-f\d]{8}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{4}-[a-f\d]{12})(?:\/(.*))?$/i);
  if (!match) return pathname;
  const parts = (match[3] || "home").split("/");
  const section = parts[0] as keyof typeof institutionSectionSlugs;
  parts[0] = Object.hasOwn(institutionSectionSlugs, section) ? institutionSectionSlugs[section] : parts[0];
  if (parts[0] === "classes" && parts[2] === "disciplinas") parts[2] = "subjects";
  return `${match[1] || ""}${match[2]}/${parts.join("/")}`;
}
